'use client';

import React, { forwardRef } from 'react';

import { ProductSliderDesktop } from './ProductSliderDesktop';
import { ProductSliderProps } from './types';

export const ProductSlider = forwardRef<HTMLDivElement, ProductSliderProps>((props, ref) => {
  return <ProductSliderDesktop {...props} />;
});

ProductSlider.displayName = 'ProductSlider';

export * from './ProductCard';
